import { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useParams, useNavigate } from "react-router-dom";

import { generalMusicSchema } from "../../ZodSchemas/MusicSchema";
import GeneralMusicData from "../../components/EditMusic";
import { musicService } from "../../services";
import ErrorModal from "../../components/UI/Error";
import Spinner from "../../components/UI/Spinner";

const MusicUpdateForm = () => {
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState(false);
  const [edit, setEdit] = useState(true);
  const [errorMessage, setErrorMessgae] = useState(null);

  const { id } = useParams();
  const navigate = useNavigate();
  const methods = useForm({
    resolver: zodResolver(generalMusicSchema),
  });

  const {
    handleSubmit,
    setValue,
    formState: { errors },
  } = methods;

  useEffect(() => {
    const fetchMusic = async () => {
      try {
        setError(false);
        let music = await musicService.singleMusic(id);

        const givenTime = new Date(music.createdAt).getTime();
        const now = Date.now();
        const diffInMs = now - givenTime;
        const hours24 = 24 * 60 * 60 * 1000;
        if (diffInMs > hours24) {
          setEdit(false);
        }
        music = {
          ...music,
          releaseDate: music.releaseDate.split("T")[0],
          genre: music.genre?.join(" "),
          featuredArtiste: music.featuredArtiste?.join(" ") || "",
        };

        Object.keys(music).forEach((key) => setValue(key, music[key]));
      } catch (error) {
        setError(true);
        console.error("Failed to fetch music data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchMusic();
  }, [id, setValue]);

  const onSubmit = async (data) => {
    setErrorMessgae(null);
    try {
      setError(false);
      await musicService.updateMusic(id, data);
      navigate("/user/my-dashboard/music/all");
    } catch (error) {
      setError(true);
      setErrorMessgae({ title: "Updating", message: "update" });
    } finally {
      setUpdating(false);
    }
  };
  if (loading)
    return (
      <div className="grid place-content-center h-[60vh]">
        <Spinner />
      </div>
    );
  if (error)
    return (
      <ErrorModal
        isOpen={error}
        onClose={() => setError(false)}
        title={`Error ${errorMessage?.title || "Getting"} Music Details`}
        message={`There is error while trying to ${
          errorMessage?.message || "fetch"
        } the music details. Please check your internet contivities and refresh this page to try again`}
      />
    );
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="mb-4">
        <h1 className="text-xl capitalize font-bold mb-4">Update Music</h1>
        {!edit && (
          <h1 className="text-red-400">
            You have exceeded the total time allowed for editing!
          </h1>
        )}
        <GeneralMusicData errors={errors} />
        {edit ? (
          <button type="submit" className="formSubmitBtn" disabled={updating}>
            {updating ? "Updating..." : "Update Music"}
          </button>
        ) : (
          <h1 className="trext-red-400">
            You have exceeded the total time allowed for editing!
          </h1>
        )}
      </form>
    </FormProvider>
  );
};

export default MusicUpdateForm;
